module.exports = __webpack_public_path__ + "img/w3_chevron_right_light.01f74951.png";